import { render, staticRenderFns } from "./SeniorManagerUser.vue?vue&type=template&id=05ce178b&scoped=true&"
import script from "./SeniorManagerUser.vue?vue&type=script&lang=js&"
export * from "./SeniorManagerUser.vue?vue&type=script&lang=js&"
import style0 from "./SeniorManagerUser.vue?vue&type=style&index=0&id=05ce178b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ce178b",
  null
  
)

export default component.exports